<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('商家退货地址.收货人名字')" prop="receiverName" >
        <a-input v-model="form.receiverName" :maxLength="36" :placeholder="$t('通用.输入.请输入')+$t('商家退货地址.收货人名字')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商家退货地址.收货人手机号码')" prop="receiverMobile" >
        <a-input v-model="form.receiverMobile" :maxLength="36" :placeholder="$t('通用.输入.请输入')+$t('商家退货地址.收货人手机号码')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商家退货地址.邮政编码')" prop="postCode" >
        <a-input v-model="form.postCode" :maxLength="15" :placeholder="$t('通用.输入.请输入')+$t('商家退货地址.邮政编码')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商家退货地址.省')" prop="province" >
        <a-input v-model="form.province" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('商家退货地址.省')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商家退货地址.城市')" prop="city" >
        <a-input v-model="form.city" :maxLength="20" :placeholder="$t('通用.输入.请输入')+$t('商家退货地址.城市')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商家退货地址.区')" prop="area" >
        <a-input v-model="form.area" :maxLength="20" :placeholder="$t('通用.输入.请输入')+$t('商家退货地址.区')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商家退货地址.具体地址')" prop="addr" >
        <a-input v-model="form.addr" :maxLength="256" :placeholder="$t('通用.输入.请输入')+$t('商家退货地址.具体地址')" />
      </a-form-model-item>

      <a-form-model-item  class="margin-bottom-10" :label="$t('商家退货地址.默认地址')" prop="defaultAddr">
        <a-radio-group v-model="form.defaultAddr"  button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item  class="margin-bottom-10" :label="$t('商家退货地址.状态')" prop="status">
        <a-radio-group v-model="form.status"  button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>


      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAddr, addAddr, updateAddr } from '@/api/zb/addr'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        shopId: null,

        receiverName: null,

        receiverMobile: null,

        receiverTelephone: null,

        postCode: null,

        provinceId: null,

        province: null,

        cityId: null,

        city: null,

        areaId: null,

        area: null,

        addr: null,

        defaultAddr: null,

        status: 0,

        createTime: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        receiverName: [
          { required: true, message: this.$t('商家退货地址.收货人名字')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        receiverMobile: [
          { required: true, message: this.$t('商家退货地址.收货人手机号码')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        postCode: [
          { required: true, message: this.$t('商家退货地址.邮政编码')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        province: [
          { required: true, message: this.$t('商家退货地址.省')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('商家退货地址.城市')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        area: [
          { required: true, message: this.$t('商家退货地址.区')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        addr: [
          { required: true, message: this.$t('商家退货地址.具体地址')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        defaultAddr: [
          { required: true, message: this.$t('商家退货地址.默认地址')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        shopId: null,
        receiverName: null,
        receiverMobile: null,
        receiverTelephone: null,
        postCode: null,
        provinceId: null,
        province: null,
        cityId: null,
        city: null,
        areaId: null,
        area: null,
        addr: null,
        defaultAddr: null,
        status: 0,
        createTime: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAddr({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateAddr(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addAddr(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
